/* eslint-disable no-param-reassign */
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { getSampleStatusList, SAMPLE_STATE_DATA } from 'component/waterfall.card/sampleCardExamine/common'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

export const sampleSourceData = [
  { label: '原创', value: 1 },
  { label: '买款', value: 2 },
  { label: '合作商', value: 3 },
  { label: '数字款', value: 4 }
]

export const sampleTypeData = [
  { label: '基础款', value: 1 },
  { label: '主题款', value: 2 },
  { label: '形象款', value: 3 }
]

export const sampleSeasonData = [
  { label: '春季', value: 1 },
  { label: '夏季', value: 2 },
  { label: '秋季', value: 3 },
  { label: '冬季', value: 4 }
]

export const sampleSizeData = [
  { label: 'S', value: 'S' },
  { label: 'M', value: 'M' },
  { label: 'L', value: 'L' },
  { label: 'XL', value: 'XL' },
  { label: 'XXL', value: 'XXL' },
  { label: 'XXXL', value: 'XXXL' },
  { label: 'XXXXL', value: 'XXXXL' }
]

// 样衣导出格式
export const EXPORT_SAMPLE_CONFIG = {
  name: '样衣',
  column: [{ name: '样衣ID', dataIndex: 'sampleCode' },
    { name: '样衣主图', dataIndex: 'mainImgUrl', type: 'image', convert: (txt) => { return resize(txt) } },
    { name: '主图链接', dataIndex: 'mainImgUrl' },
    { name: '样衣名称', dataIndex: 'name' },
    { name: '样衣品类', dataIndex: 'category' },
    { name: '价格', dataIndex: 'price' },
    { name: '面料', dataIndex: 'fabric' },
    { name: '辅料', dataIndex: 'accessories' },
    { name: '风格', dataIndex: 'style' },
    { name: '季节', dataIndex: 'season', convert: (txt) => { return (txt ? sampleSeasonData.find(m => m.value === txt).label : '') } },
    { name: '颜色', dataIndex: 'color' },
    { name: '样衣尺码', dataIndex: 'size' },
    { name: '样衣状态', dataIndex: 'state', convert: (txt) => { return (txt ? SAMPLE_STATE_DATA.find(m => m.value === txt).label : '') } },
    { name: '样衣来源', dataIndex: 'source', convert: (txt) => { return (txt ? sampleSourceData.find(m => m.value === txt).label : '') } },
    { name: '样衣类型', dataIndex: 'type', convert: (txt) => { return (txt ? sampleTypeData.find(m => m.value === txt).label : '') } },
    { name: '样衣数量', dataIndex: 'num' },
    { name: '设计师', dataIndex: 'designerName' },
    { name: '设计师助理', dataIndex: 'designerAssistantName' },
    { name: '打版师', dataIndex: 'typesetter' },
    { name: '样衣工', dataIndex: 'sampleMaker' },
    { name: '备注', dataIndex: 'remarks' },
    { name: '更新时间', dataIndex: 'updatedAt' },
    { name: '创建时间', dataIndex: 'createdAt' },
  ],
  rowHeight: 150
}
const resize = (imgUrl) => {
  if (imgUrl.includes('.oss-cn')) {
    imgUrl += `?x-oss-process=image/resize,s_200&${new Date().getTime()}`
  } else if (imgUrl.includes('https://img.alicdn.com/')) {
    imgUrl += '_200x200.jpg'
  }
  return imgUrl
}

export default (props) => {
  // 风格，面料，辅料
  /*
  type:
    styleAllList
    fabricAllList
    accessoriesAllList
  */
  const { value, type, onChange, placeholder } = props
  const [labels, setLabels] = useState(null)
  useEffect(() => {
    fetchLabels()
  }, [])
  const fetchLabels = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/get-label-list')
      setLabels(res)
    } catch (err) {
      console.error(err)
    }
  }
  return <Select
    value={value}
    overlayStyle={{ zIndex: 1001 }}
    data={labels ? labels[type]?.map(m => ({ label: m, value: m })) : []}
    placeholder={placeholder}
    onChange={onChange}
  />
}

// 样衣状态
export const SampleState = forwardRef((props, ref) => {
  const { placeholder = '样衣状态' } = props
  const [option, setOption] = useState()
  const [isCustomProcess, setIsCustomProcess] = useState(false)

  useEffect(() => {
    fetchData()
  }, [])

  useImperativeHandle(ref, () => {
    return {
      isCustomProcess
    }
  })

  const fetchData = () => {
    request.get('/zhikuan/ins/inspiration/work/platform/get-sample-process').then(res => {
      if (res && res?.length) {
        const result = getSampleStatusList({ process: res })
        setOption(result)
        setIsCustomProcess(true)
      } else {
        setOption(SAMPLE_STATE_DATA)
        setIsCustomProcess(false)
      }
    })
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{
    isCustomProcess ? <Select.Cascade
      {...props}
      multi={false}
      hiddenSearch
      rootSelectable
      data={option}
      allowClear={false}
      overlayStyle={{ zIndex: 1001 }}
      placeholder={placeholder}
    /> : <Select
      {...props}
      data={option}
      overlayStyle={{ zIndex: 1001 }}
      placeholder={placeholder}
    />
  }
  </>
})
// 样衣类型
export const SampleType = (props) => {
  const { placeholder = '样衣类型' } = props
  return <Select
    {...props}
    data={sampleTypeData}
    overlayStyle={{ zIndex: 1001 }}
    placeholder={placeholder}
  />
}
// 样衣季节
export const SampleSeason = (props) => {
  const { placeholder = '样衣季节' } = props
  return <Select
    {...props}
    data={sampleSeasonData}
    overlayStyle={{ zIndex: 1001 }}
    placeholder={placeholder}
  />
}
